import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=61a5207a&"
import script from "./ReservationList.vue?vue&type=script&lang=js&"
export * from "./ReservationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports